import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getAllGeneratableDocumentsTemplates } from '@dealstack/frontend/shared/dataExchange/services/god.service.ts';

export const useManageGeneratableDocumentsController = () => {
	const getAllTemplatesRequest = useQuery({
		queryKey: [API_PATHS.GODMODE_GENERATABLE_DOCUMENTS_TEMPLATES_GET],
		queryFn: ({ signal }) =>
			getAllGeneratableDocumentsTemplates(
				API_PATHS.GODMODE_GENERATABLE_DOCUMENTS_TEMPLATES_GET,
				signal
			),
	});

	return { documentsTemplates: getAllTemplatesRequest.data?.payload };
};
